import React from "react";  

import {  
    
} from "./styled";

import ContainerAuthenticated from "containers/Authenticated";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import DashboardFormsPaycheck from "components/Dashboard/Forms/Paycheck";

export default function DashboardFormPaycheck(){  

    const history = useHistory(); 
    const navigate = to => history.push(`/${ to }`); 

    return ( 
        <>
            <ContainerAuthenticated page={"paycheck"}> 
                <Row> 
                    <Col sm={12} md={12}>
                        <DashboardFormsPaycheck />
                    </Col>
                </Row>
            </ContainerAuthenticated> 
        </>
    );
}